module.exports = __webpack_public_path__ + "img/42.9b53b006.jpg";